import React, { FunctionComponent, SVGProps } from 'react'

export const IconExcel: FunctionComponent<SVGProps<SVGSVGElement>> = (
  props
) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    stroke="var(--typo-brand, #0062ca)"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M9.33325 2V4.66667C9.33325 4.84348 9.40349 5.01305 9.52851 5.13807C9.65354 5.2631 9.82311 5.33333 9.99992 5.33333H12.6666"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3.33325 8V3.33333C3.33325 2.97971 3.47373 2.64057 3.72378 2.39052C3.97382 2.14048 4.31296 2 4.66659 2H9.33325L12.6666 5.33333V8"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M2.66675 10L5.33341 14"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M2.66675 14L5.33341 10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.3333 13.5C11.3333 13.776 11.5573 14 11.8333 14H12.6666C12.8434 14 13.013 13.9298 13.138 13.8047C13.263 13.6797 13.3333 13.5101 13.3333 13.3333V12.6667C13.3333 12.4899 13.263 12.3203 13.138 12.1953C13.013 12.0702 12.8434 12 12.6666 12H11.9999C11.8231 12 11.6535 11.9298 11.5285 11.8047C11.4035 11.6797 11.3333 11.5101 11.3333 11.3333V10.6667C11.3333 10.4899 11.4035 10.3203 11.5285 10.1953C11.6535 10.0702 11.8231 10 11.9999 10H12.8333C12.9659 10 13.093 10.0527 13.1868 10.1464C13.2806 10.2402 13.3333 10.3674 13.3333 10.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.33325 10V14H9.33325"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
